import { Box } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import { useFetchCurrentCarModel } from '../../../../../hooks/queries/useFetchCurrentCarModel';
import useIsTablet from '../../../../../../common/react/useIsTablet';
import customise from '../../../../../constants/customise';
import ScrollToWrapper from '../../../../presentational/ScrollToWrapper';
import ModelSelectorBase from './modelSelectorBase/ModelSelectorBase';
import ChangeModel from '../../changeModel/ChangeModel';
import ModelContainer from '../ModelContainer';
import modelSectionContainerStyles from './modelSectionContainerStyles';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

const ModelSectionContainer: FunctionComponent = () => {
  const { selectedCar } = useCustomizeCarContext();
  const carId = selectedCar?.car?.code;
  const { selectedCarModelData, error } = useFetchCurrentCarModel();
  const model = selectedCarModelData?.car.model.attributes.shortname;
  const isTablet = useIsTablet();
  const sectionName = customise.VARIANT_ITEM.name;
  const styles = modelSectionContainerStyles();

  if (!carId) {
    return null;
  }

  return (
    <Box pb={6} pt={!isTablet ? 6 : 0} className={styles.container} data-test={`customise:${sectionName}`}>
      <ScrollToWrapper target={sectionName}>
        <ModelSelectorBase sectionName={sectionName} error={error}>
          <ChangeModel isComplexModel={true} variant={'caption'} align={'left'} />
          <ModelContainer selectedCarModelData={selectedCarModelData} model={model} />
        </ModelSelectorBase>
      </ScrollToWrapper>
    </Box>
  );
};

export default ModelSectionContainer;
